import { ISalaryListItem, SalaryListItem } from "./salaryListItem";
import { Base } from "../../framework/base";

export interface ISalaryListItems {
    items: ISalaryListItem[];
    hasMore: boolean;
    page: number;
}

export class SalaryListItems implements ISalaryListItems {
    items: SalaryListItem[];
    hasMore: boolean;
    page: number;

    constructor();
    constructor(obj: ISalaryListItem);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.items = Base.getTypedArray<SalaryListItem>(obj ? obj.items : null, SalaryListItem);
    }
}